import { flow, types, getEnv } from 'mobx-state-tree'
import { ROLES } from 'constants/account.roles'
import * as TIMEFRAMES from 'constants/timeframes'
import { Jurisdiction } from 'store/models/other/jurisdiction'

import { extendMember } from '../core'
import { Wallet } from '../wallet'

const createEnum = (type) =>
  types.model(`${type}Enum`, {
    [type]: types.string,
    description: types.string,
  })

const CategoryEnum = createEnum('category')
const SubCategoryEnum = createEnum('subCategory')

const InWinsStatistics = types.model({
  all: 0,
  lastMonth: 0,
  lastYear: 0,
})

const Address = types.model({
  address1: '',
  address2: '',
  city: '',
  state: '',
  zip: '',
  country: '',
})

export const Sponsor = extendMember(
  types
    .model('Sponsor', {
      id: types.identifierNumber,
      email: types.maybeNull(types.string),
      nickName: types.maybeNull(types.string),
      category: types.maybeNull(types.array(CategoryEnum)),
      jurisdiction: types.maybeNull(Jurisdiction),
      subCategory: types.maybeNull(types.array(SubCategoryEnum)),
      role: types.maybeNull(
        types.enumeration('Roles', [ROLES.SPONSOR, ROLES.ADMIN])
      ),
      logo: types.maybeNull(types.string),
      website: types.maybeNull(types.string),
      wallet: types.optional(Wallet, { balance: 0 }),
      inwinStatistics: types.optional(InWinsStatistics, {
        all: 0,
        lastMonth: 0,
        lastYear: 0,
      }),
      address: types.optional(Address, {}),
      taxId: types.maybeNull(types.string),
    })
    .views((self) => ({
      get displayName() {
        return self.nickName || self.email
      },
    }))
    // TODO: temp solution and should be removed in favour to simplify calls to services
    .actions((self) => {
      const {
        services: { statisticsService },
      } = getEnv(self)
      return {
        loadInwinsStatistics: flow(function* loadInwinsStatistics() {
          const [allStat, lastMonthStat, lastYearStat] = yield Promise.all([
            statisticsService.getBeneficiaryInwinStatistics(
              self.id,
              TIMEFRAMES.ALL
            ),
            statisticsService.getBeneficiaryInwinStatistics(
              self.id,
              TIMEFRAMES.LAST_MONTH
            ),
            statisticsService.getBeneficiaryInwinStatistics(
              self.id,
              TIMEFRAMES.LAST_YEAR
            ),
          ])

          self.inwinStatistics = {
            all: allStat.total,
            lastMonth: lastMonthStat.total,
            lastYear: lastYearStat.total,
          }

          return self.inwinStatistics
        }),
      }
    }),
  {
    type: ROLES.SPONSOR,
  }
)
